module.exports = __webpack_public_path__ + "img/bg-mision-2-9.7307adce.jpg";